import React, { useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './main.css'; // Assuming common styles are here

const SearchBar = ({ products = [] }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  // Memoized suggestions calculation
  const filteredSuggestions = useMemo(() => {
    if (!searchTerm.trim()) {
      return [];
    }
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return products
      .filter((product) => {
        // 1. Check Product Name (String)
        const lowerCaseName = product["Product name"]?.toLowerCase() || '';
        if (lowerCaseName.includes(lowerCaseSearchTerm)) {
          return true;
        }

        // 2. Check SKU (Number -> String)
        // ** Convert SKU to string BEFORE calling includes **
        const skuAsString = product["SKU"]?.toString() || ''; // Safely convert number to string
        if (skuAsString.includes(lowerCaseSearchTerm)) { // Now compare against the search term
             return true;
        }

        // 3. Check 'aka' tags (String)
        const akaTags = product.aka ? product.aka.split(',').map(tag => tag.trim().toLowerCase()) : [];
        if (akaTags.some(tag => tag.includes(lowerCaseSearchTerm))) {
          return true;
        }

        return false; // No match found
      })
      .slice(0, 8); // Limit suggestions
  }, [searchTerm, products]); // Dependencies for memoization

  // Handle search submission (e.g., pressing Enter)
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    if (searchTerm.trim()) {
      setShowSuggestions(false);
      navigate(`/products?search=${encodeURIComponent(searchTerm.trim())}`);
      setSearchTerm('');
    }
  };

  return (
    <div className="search-container-global">
      <form onSubmit={handleSearchSubmit}>
        <input
          type="search"
          className="search search-global-input"
          placeholder='Search products by Name or SKU...'
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setShowSuggestions(e.target.value.trim().length > 0);
          }}
          onFocus={() => { if (searchTerm.trim()) setShowSuggestions(true); }}
          onBlur={() => { setTimeout(() => setShowSuggestions(false), 200); }}
          aria-label="Search Products"
        />
      </form>
      {showSuggestions && filteredSuggestions.length > 0 && (
        <ul className="search-suggestions search-suggestions-global">
          {filteredSuggestions.map((suggestion) => (
            <li key={suggestion.id}>
              <Link
                // ** Use product ID for navigation **
                to={`/products/${suggestion.id}`} // Link to detail page using ID
                onClick={() => {
                  setSearchTerm('');
                  setShowSuggestions(false);
                }}
              >
                {suggestion["Product name"]}
                {/* Show SKU in suggestion */}
                <span className="suggestion-sku"> (SKU: {suggestion.SKU})</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchBar;